import { FormFieldData } from "modules/forms";
import { OpportunityEntity } from "shared/types/domain/OpportunityEntity";
import { IMapper } from "shared/types/IMapper";
import { ConvertToUTC } from "shared/utils/date.utils";
import { UpdateOpportunityRequest } from "../mutations/ammend-opportunity.mutations.types";

export class UpdateOpportunityRequestMapper implements IMapper<FormFieldData<OpportunityEntity>, UpdateOpportunityRequest> {
    map(entity: FormFieldData<OpportunityEntity>): UpdateOpportunityRequest {
        return {
            opportunityId: entity.nearMissId,
            depotPcId: entity.depotPcId,
            whatHappened: entity.whatHappened,
            reporterType: entity.reporterType,
            anonymousEntry: entity.anonymousEntry,
            contactName: entity.reporterContactName,
            contactPhoneNumber: entity.reporterPhoneNumber,
            contactEmail: entity.reporterEmail,
            incidentDate: ConvertToUTC(entity.incidentDate),
            enhancements: {
                reachId: entity.reachId,
                processId: entity.processId 
            }
        }
    };
}